import { lazy, Suspense } from 'react';
import Box from 'fe-design-base/atoms/Box';

import { cxHelpers } from 'util/className';

import ApplicationConversationsView from '../../ApplicationConversationsView';
import { MESSAGE_DRAWER_TABS } from '../../constants';
import TeamEmailsView from '../../TeamEmailsView';

import MessengerHeader from './MessengerHeader';

const MessagesView = lazy(() =>
  import(
    /* webpackChunkName: "MessagesView" */ 'features/messenger/MessagesView'
  )
);

const { cx } = cxHelpers('MessengerView');

const MessengerDrawer = ({
  shouldHideTabs,
  currentTab,
  handleClose,
  handleTabChange,
  tabs,
  repackagingEnabled,
  showMessengerScrim,
  menuOpen,
  handleMenuClose,
  toggleMenuOpen,
  showMenu,
  hideDefaultBorder = false,
  iconSize = 'medium',
}) => (
  <Box className={`${cx({ 'no-border': hideDefaultBorder }, 'MessageDrawer')}`}>
    {!shouldHideTabs && (
      <MessengerHeader
        currentTab={currentTab}
        handleTabChange={handleTabChange}
        tabs={tabs}
        handleClose={handleClose}
        repackagingEnabled={repackagingEnabled}
        showMessengerScrim={showMessengerScrim}
        menuOpen={menuOpen}
        handleMenuClose={handleMenuClose}
        toggleMenuOpen={toggleMenuOpen}
        showMenu={showMenu}
        iconSize={iconSize}
      />
    )}

    {currentTab === MESSAGE_DRAWER_TABS.TEAM && (
      <Suspense fallback={<Box />}>
        <MessagesView handleClose={handleClose} />
      </Suspense>
    )}

    {currentTab === MESSAGE_DRAWER_TABS.APPLICANTS && (
      <ApplicationConversationsView />
    )}

    {(currentTab === MESSAGE_DRAWER_TABS.EMAILS ||
      currentTab === MESSAGE_DRAWER_TABS.ANNOUNCEMENTS) && (
      <TeamEmailsView onClose={handleClose} />
    )}
  </Box>
);

export default MessengerDrawer;
